import firebase from "firebase/app";
import "firebase/functions";
import "firebase/firestore";

export interface RawUserInfo {
  displayName: string;
  email: string;
  role: string;
}

export interface RawNewUserInfo extends RawUserInfo {
  password: string;
}

export default class User {
  public static async getUsers(): Promise<RawUserInfo[]> {
    const getUsers = firebase.functions().httpsCallable("getStaffUsers");
    const result = await getUsers();
    return result.data;
  }

  public static async createUser(userInfo: RawNewUserInfo) {
    const createUser = firebase.functions().httpsCallable("createUser");
    const result = await createUser(userInfo);
    return result.data.success === true;
  }

  public static async deleteUser(email: string): Promise<boolean> {
    const deleteUser = firebase.functions().httpsCallable("deleteUser");
    const result = await deleteUser({ email });
    return result.data.success === true;
  }

  public static async setUserRole(
    email: string,
    role: string
  ): Promise<boolean> {
    switch (role) {
      case "admin":
        return this.setAdmin(email);
      case "moderator":
        return this.setModerator(email);
      default:
        return false;
    }
  }

  private static async setAdmin(email: string): Promise<boolean> {
    const setAdmin = firebase.functions().httpsCallable("setAdmin");
    const result = await setAdmin({ email });
    return result.data.success === true;
  }

  private static async setModerator(email: string): Promise<boolean> {
    const setModerator = firebase.functions().httpsCallable("setModerator");
    const result = await setModerator({ email });
    return result.data.success === true;
  }
}
